import { Layout, Input } from "antd";
import { Content } from "antd/es/layout/layout";
import _ from "lodash";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";

import { ReactComponent as ICON_MENU_ARROW } from "@assets/svgs/ICON_MENU_ARROW.svg";
import { Button } from "@components/Button";
import Header from "@components/Header";
import { Icon } from "@components/Icon";
import { InnerContents } from "@components/InnerContents";
import { SideMenu } from "@components/SideMenu";
import { Text } from "@components/Text";
import { COLOR_DARK, COLOR_GREY_1, COLOR_WHITE } from "@static/COLORS";
import { CONTENT_STYLES } from "@static/CONTENT_STYLES";
import { FILTER_SIZE, MENU_SIZE } from "@static/SIZE";
import { getAuthUserProfile } from "@utils/getAuthUserProfile";
import { getUserExtraCustomers } from "@utils/getUserExtraCustomers";
import { fetchAPI } from "@utils/https/fetchAPI";

const SectionMainAction = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: ${COLOR_WHITE};
  padding: 8px;
  border-radius: 6px;
  height: 50px;
  box-sizing: border-box;
`;

const SectionLists = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  /* gap: 20px; */
  overflow: scroll;
`;

const SectionGroupLocation = styled.div`
  width: 100%;
  flex-shrink: 0;
`;

const SectionCompanyName = styled.div`
  width: fit-content;
  display: flex;
  padding: 8px 24px 8px 16px;
  align-items: center;
  justify-content: space-between;
  border-radius: 8px 32px 0px 0px;
  background-color: ${COLOR_DARK};
  min-width: 139px;
`;

const SectionListLocation = styled.div`
  display: flex;
  gap: 16px;
  width: 100%;
  overflow-x: scroll;
  padding: 16px;
  background: ${COLOR_GREY_1};
  /* height: 198px; */
`;

const SectionLocationName = styled.div``;

const SectionLocationMediaFiles = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  width: 100%;
  justify-content: flex-end;
`;

const SectionLocationItem = styled(Button)`
  flex-shrink: 0;
  display: flex;
  padding: 16px;
  justify-content: space-between;
  flex-direction: column;
  align-items: flex-start;
  border-radius: 0px 16px 16px 16px;
  background: linear-gradient(181deg, #fff 50%, #e9fff9 99.52%);
  box-shadow: 0px 4px 16px 0px #def4f5;
  height: 166px;
  width: 269px;
`;

const Line = styled.div`
  width: 100%;
  height: 1px;
  margin-top: 8px;
  margin-bottom: 8px;
  background-color: rgba(0, 0, 0, 0.1);
`;

export default () => {
  const navigate = useNavigate();
  const [filterText, setFilterText] = useState("");
  const [dataList, setDataList] = useState([]);

  const authUserProfile = getAuthUserProfile();
  const user_type = _.get(authUserProfile, ["user_type"]);
  const category_customer_id = _.get(authUserProfile, ["category_customer_id"]);
  const userManageLocationIdList = _.get(authUserProfile, [
    "userManageLocationIdList",
  ]);

  const allCustomers = getUserExtraCustomers();

  const [collapsedSections, setCollapsedSections] = useState([]);

  const onHandleToggleCollapse = ({ customerId }) => {
    const updateCollapsedSections = _.includes(collapsedSections, customerId)
      ? _.filter(collapsedSections, (id) => id !== customerId)
      : [...collapsedSections, customerId];

    setCollapsedSections(updateCollapsedSections);
  };

  const onHandleFilterChange = (e) => {
    const value = _.get(e, ["target", "value"]);
    setFilterText(value);
  };

  const initData = async () => {
    const resp = await fetchAPI({
      method: "post",
      path: "/api/v1/get-customers-with-locations-ads-campaign",
      isAuth: true,
      data: {
        user_type,
        category_customer_id: allCustomers,
        userManageLocationIdList: userManageLocationIdList,
      },
    });

    if (_.get(resp, ["status"])) {
      const results = _.chain(resp).get(["result"]).value();
      const collapsed = _.chain(results)
        .filter((item) => _.isEmpty(_.get(item, ["locations"])))
        .map((item) => _.get(item, ["id"]))
        .value();
      setCollapsedSections(collapsed);
      setDataList(results);
    }
  };

  const onHandleRedirect = ({ customerId, locationId, locationName }) => {
    navigate("/campaigns-list", {
      state: { customerId, locationId, locationName },
    });
  };

  useEffect(() => {
    initData();
  }, []);

  const filteredDataSource = _.filter(dataList, (item) => {
    const customerName = _.toLower(_.get(item, ["customer_name"], ""));
    const lowerFilterText = _.toLower(filterText);

    const matchCustomerName = _.includes(customerName, lowerFilterText);

    const locations = _.get(item, ["locations"], []);
    const matchLocationName = _.some(locations, (location) => {
      const locationName = _.toLower(_.get(location, ["name"], ""));
      return _.includes(locationName, lowerFilterText);
    });

    return matchCustomerName || matchLocationName;
  });

  return (
    <Layout hasSider>
      <SideMenu />
      <Layout style={{ marginLeft: MENU_SIZE }}>
        <Header />
        <Content style={CONTENT_STYLES}>
          <InnerContents style={{ overflow: "hidden" }}>
            <SectionMainAction>
              <Input
                placeholder="Filter by project name"
                value={filterText}
                onChange={(e) => onHandleFilterChange(e)}
                style={{ width: FILTER_SIZE }}
              />
            </SectionMainAction>

            <SectionLists>
              {_.map(filteredDataSource, (item, index) => {
                const customerId = _.get(item, ["id"]);
                const locations = _.get(item, ["locations"]);
                const filteredDataLocations = _.filter(locations, (item) => {
                  const itemName = _.chain(item)
                    .get(["name"])
                    .toLower()
                    .value();
                  const lowerFilterText = _.toLower(filterText);
                  return _.includes(itemName, lowerFilterText);
                });
                const isCollapsed = !_.includes(collapsedSections, customerId);
                return (
                  <SectionGroupLocation key={index}>
                    <SectionCompanyName>
                      <Text color={COLOR_WHITE}>
                        {_.get(item, ["customer_name"])}
                      </Text>
                      <Icon
                        onClick={() => onHandleToggleCollapse({ customerId })}
                        isCursor
                        width={"16px"}
                        height={"16px"}
                        fill={"rgba(255, 255, 255, 0.4)"}
                        isRotated={!isCollapsed}
                      >
                        <ICON_MENU_ARROW />
                      </Icon>
                    </SectionCompanyName>
                    {isCollapsed && (
                      <SectionListLocation>
                        {_.map(
                          filteredDataLocations,
                          (locationItem, locationIndex) => {
                            const locationId = _.get(locationItem, ["id"]);
                            const locationName = _.get(locationItem, ["name"]);

                            const totalAds = _.chain(locationItem)
                              .get(["advertisingCampaign"])
                              .size()
                              .value();

                            return (
                              <SectionLocationItem
                                key={locationIndex}
                                onClick={() =>
                                  onHandleRedirect({
                                    customerId,
                                    locationId,
                                    locationName,
                                  })
                                }
                              >
                                <SectionLocationName>
                                  <Text fontWeight="600" fontSize="14px">
                                    {_.get(locationItem, ["name"])}
                                  </Text>
                                </SectionLocationName>
                                <SectionLocationMediaFiles>
                                  <Text
                                    fontWeight="500"
                                    fontSize="27px"
                                    lineHeight="31px"
                                    style={{ marginTop: 16 }}
                                  >
                                    {totalAds}
                                  </Text>
                                  <Text fontWeight="500" fontSize="10px">
                                    Campaigns
                                  </Text>
                                </SectionLocationMediaFiles>
                              </SectionLocationItem>
                            );
                          }
                        )}
                      </SectionListLocation>
                    )}
                    <Line />
                  </SectionGroupLocation>
                );
              })}
            </SectionLists>
          </InnerContents>
        </Content>
      </Layout>
    </Layout>
  );
};
